import { VacancyField } from "./VacancyField";

import { VacancyFieldConfig } from "@/lib/vacancies";

type VacancyTextFieldsProps = {
  fields: VacancyFieldConfig[];
};

export const VacancyTextFields: React.FC<VacancyTextFieldsProps> = ({
  fields,
}) => {
  return (
    <div className="flex w-full flex-col gap-4">
      {fields.map((field) => (
        <div
          key={field.key}
          className="flex w-full flex-col gap-2 rounded-lg border border-border p-3"
        >
          <VacancyField
            label={field.headerLabel}
            text={field.header}
            badge={field.headerBadge}
          />
          <VacancyField label={field.contentLabel} text={field.content} />
        </div>
      ))}
    </div>
  );
};
